import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'HhMmToAmPm' })
export class TimeHhMmToAmPmPipe implements PipeTransform {
  transform(
    hhMmTime: string | undefined,
    closedAllDayValue: string
  ): string | undefined {
    if (!hhMmTime) {
      return undefined;
    }
    if (hhMmTime === '24:00') {
      return '12AM*';
    }
    if (hhMmTime === closedAllDayValue) {
      return hhMmTime[0].toUpperCase() + hhMmTime.slice(1);
    }
    try {
      const dateObj = new Date(`July 21, 1983 ${hhMmTime}:00`);
      const dateFormatOption: Record<string, unknown> = {
        hour: 'numeric',
        hour12: true,
      };
      const minutes = dateObj.getMinutes();
      if (minutes) {
        dateFormatOption['minute'] = 'numeric';
      }

      return dateObj
        .toLocaleString('en-US', dateFormatOption)
        .replace(/\s/g, '');
    } catch (err) {
      return undefined;
    }
  }
}
